module.exports = __webpack_public_path__ + "static/media/_madeira.8a6d24cb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/_madeira.svg
// module id = 2336
// module chunks = 7